import {ApiRes} from '@type/api'
import {apiGet} from '@api/api'
import {IExchange} from '@type/exchange'
import {IApiGetSidebarKeyIdProps} from '@api/user/sidebar/getSidebar'

export const fetchExchanges = async (props?: IApiGetSidebarKeyIdProps): Promise<ApiRes<IExchange[]>> => {
    return await apiGet(`exchanges`, {cookies: props?.cookie})
}
